import Axios from 'axios';
import { TITLE, DESC } from '../utils/constant';

// 注册获取微信接口api
const registerWxApi = (url: string) => {
	window.wx.ready(function () {
		window.wx.updateAppMessageShareData({
			title: TITLE,
			desc: DESC,
			link: url,
			imgUrl: `${url.split('?')[0]}logo.png`,
		})

		window.wx.updateTimelineShareData({
			title: TITLE,
			link: url,
			imgUrl: `${url.split('?')[0]}logo.png`,
		})
	});
}

// 获取微信签名
export const getSignature = () => {
	let url = window.location.href.split('#')[0];
	Axios.get(`https://www.frontopbd.com/wxSignature?url=${encodeURIComponent(url)}`)
		.then(function (res: any) {
			let { appId, nonceStr, timestamp, signature } = res.data;
			window.wx.config({
				debug: false,
				appId: appId,
				timestamp: timestamp,
				nonceStr: nonceStr,
				signature: signature,
				jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData', 'previewImage', 'openLocation'] // 必填，需要使用的JS接口列表
			});
			registerWxApi(url);
		})
		.catch(function () {
		})
}